import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useWidth } from "../../../../../libs/hooks";
import { message } from "antd";
import { CardComponent } from "./card-component";
import { workflowThreeCount } from "../../../../../libs/apis";
import { CardWelcomeComponent } from "./card-welcome";
import WorkflowThreeListComponent from "./table-process-three";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

export const ProcessThreeComponent = ({ options }: { options: any[] }) => {
  const width = useWidth();
  const [valueThree, setValueThree] = useState("Hoy");
  const [totalThree, setTotalThree] = useState(0);

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      handleGetThree("hoy");
    } catch (err: any) {
      message.error(err.toString());
    }
  };
  const handleUpdateThree = useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueThree(fill.label);
      handleGetThree(fill.value);
    },
    [options]
  );

  const handleGetThree = async (value: string) => {
    try {
      const { data: dataOne } = await workflowThreeCount(value);
      if (!dataOne) return;
      setTotalThree(dataOne.total);
    } catch (err: any) {
      message.error(err.toString());
    }
  };

  return (
    <Grid container spacing={5} justifyContent="center">
      <Grid item xs={7} sm={4} lg={3}>
        <CardWelcomeComponent />
      </Grid>
      <Grid item xs={5} sm={2.5}>
        <CardComponent
          width={width}
          title="Proceso 3"
          quantity={totalThree}
          handleUpdate={handleUpdateThree}
          options={options}
          color="tomato"
          value={valueThree}
        />
      </Grid>
      <Grid item xs={12}>
        <WorkflowThreeListComponent />
      </Grid>
    </Grid>
  );
};
